module.exports = __webpack_public_path__ + "media/images/athletes/1554-ca8bc391528e611a082a58892dc6e311.png";